import { BubbleSeriesChart } from '@/common/dashboard/charts/BubbleSeriesChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import { useNavState } from '@/common/navState/NavStateContext';
import { Mode } from '@/common/entityFramework/enumerations/Mode';

export const McoInvPrioritizationBubbleChart = ({ selectedPbms = [], selectedPeriod, selectedCtrts =[], selectedDueDates }) => {

  const rsrc = useRsrc();
  const [data, setData] = useState();

    const { navigateTo } = useNavState();

    const navigateToDetail= (seriesName, point) => {
      const navState = {
        mode: Mode.DETAIL,
        entityId: point.entityId,
      };
  
      navigateTo('sc/mco-inv', navState);
    }

  const toUTC = (intDate) => {
    if (!intDate) return null;
    const s = intDate.toString();
    const year = +s.slice(0, 4);
    const month = +s.slice(4, 6) - 1; // months are 0-based
    const day = +s.slice(6, 8);
    return Date.UTC(year, month, day);
  };

  useEffect(() => {
    const pbmIds = selectedPbms.map(pbm => pbm.id);
    const ctrtIds = selectedCtrts.map(ctrt => ctrt.id);
    const dueDates = selectedDueDates.map(dueDate => dueDate.value);
    const reqParam = {
      periodId: selectedPeriod?.id,
      pbmIds,
      ctrtIds,
      dueDates
    };

    rsrc.data('sc', 'MCO_INV_PRIORITIZATION_BUBBLE_CHART_DATA_PLUGIN', reqParam).then(data => {
      let series = data.series;
      series = series.map((s) => ({
        ...s,
        points: s.points.map((point) => ({
          ...point,
          dueDate: point.x,
          x: toUTC(point.x),
        })),
      }));

      setData({ series });
    });
  }, [selectedPbms, selectedPeriod, selectedCtrts, selectedDueDates]);

  const dollarFormatter = (dataPointValue) => {
    return '$' + Number(dataPointValue).toLocaleString();
  }

  const dateFormatter = (dateValue) => {
    return Highcharts.dateFormat('%m-%d', dateValue);
  }

  const tooltipHeaderFormatter = (dataPoint) => {
    return `${dataPoint.code}<br>Status: ${dataPoint.label}`;
  };

  return (
    <BubbleSeriesChart
      xLabel="Due Date"
      yLabel="Disputed Amount"
      zLabel="Due Amount"
      xAxisIsDate
      xAxisFormatter={
        function () {
          return Highcharts.dateFormat('%m-%d', this.value);
        }
      }
      xTooltipValueFormatter={dateFormatter}
      yTooltipValueFormatter={dollarFormatter}
      zTooltipValueFormatter={dollarFormatter}
      tooltipHeaderFormatter={tooltipHeaderFormatter}
      onClick={ navigateToDetail }
      data={data}
    />
  );
};
